import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperTab from '@elem/ui/ef-swiper-tab';

import styles from './index.module.scss';
import EFXBoost from 'elem/ui-assets/icons/unregular/EFXBoost';
import { pad } from 'lodash';

export default function TheComp() {
    const { t } = useLang('delta3series');

    const configs = {
        navigation: false,
        hasInfo: true,
        theme: 'black',
        gap: 0,
        lists: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1775284681974/4-pc-1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1775284692078/4-m-1.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1775284692078/4-m-1.jpg',
                tab: t('MX2_item1_tab'),
                title: t.rich('MX2_item1_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('MX2_item1_desc'),

            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1775284945202/4-pc-2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1775284692286/4-m-2.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1775284692286/4-m-2.jpg',
                tab: t('MX2_item2_tab'),
                title: t.rich('MX2_item1_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('MX2_item1_desc'),

            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1775284693203/4-pc-3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1776146368938/%E6%88%BF%E8%BD%A6%E7%94%A8%E7%94%B5.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1775284692467/4-m-3.jpg',
                tab: t('MX2_item3_tab'),
                title: t.rich('MX2_item1_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('MX2_item1_desc'),
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1775284693396/4-pc-4.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1775284692654/4-m-4.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1775284692654/4-m-4.jpg',
                tab: t('MX2_item4_tab'),
                title: t.rich('MX2_item1_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('MX2_item1_desc'),
            },
        ],
        callback: () => { },
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section`} data-section-id="D3-MX2" id='D3-MX2'>
            <EfSpec className="spec-m" />
            <div className="x-boost">
                <EFXBoost />
            </div>
            <EfSwiperTab {...configs} />
            <EfSpec className="spec-x" />
        </div>
    );
}
